import PaymentInfoModal from './PaymentInfoModal';

export { PaymentInfoModalButton } from './PaymentInfoModal';

export default PaymentInfoModal;
